import { Table } from "reactstrap";
import InvoiceTableHeader from "./InvoiceTableHeader";
import InvoiceTableBody from "./InvoiceTableBody";
import InvoiceTableTotal from "./InvoiceTableTotal";

const InvoiceTable = ({data}:any) => {
  return (
    <td>
      <Table responsive borderless style={{ width: "100%", borderSpacing:4, marginBottom:20}} >
        <thead>
          <InvoiceTableHeader />
        </thead>
        <tbody>
          <InvoiceTableBody  data={data}/>
          <InvoiceTableTotal data={data}/>
        </tbody>
      </Table>
    </td>
  );
};

export default InvoiceTable;
